import { render } from "./rtctx.vue?vue&type=template&id=1b964637&scoped=true"
import script from "./rtctx.vue?vue&type=script&lang=js"
export * from "./rtctx.vue?vue&type=script&lang=js"

import "./rtctx.vue?vue&type=style&index=0&id=1b964637&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b964637"]])

export default __exports__